// extracted by mini-css-extract-plugin
export default {"workspace":"style_workspace__X2IZG","title":"style_title__7bgcf","trashItemsList":"style_trashItemsList__pG1hA"};